import React from "react";
import Herospace from "../components/Herospace";
import MobileResult from "../components/mobile/MobileResult";
import Result from "../components/Result";
import useResponsive from "../hooks/useResponsive";

const ResultView = () => {
  const { Mobile, Default } = useResponsive();

  return (
    <>
      <Herospace />
      <Default>
        <Result />
      </Default>
      <Mobile>
        <MobileResult />
      </Mobile>
    </>
  );
};

export default ResultView;
